export default ".grid {\n  display: grid;\n  min-width: 400px;\n}";